<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? '(1) Integration Status' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <configuration-connection />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '(2a) Contact Properties' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <configuration-premapped-contact-mappings />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '(2b) Order Properties' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <configuration-premapped-order-mappings />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '(2c) Product Properties' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <configuration-premapped-product-mappings />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '(2d) Line Item Properties' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <configuration-premapped-line-item-mappings />
      </div>
    </vs-tab>  
  </vs-tabs>
</template>

<script>
import ConfigurationConnection from './ConfigurationConnection.vue'
import ConfigurationPremappedContactMappings from './ConfigurationPremappedContactMappings.vue'
import ConfigurationPremappedOrderMappings from './ConfigurationPremappedOrderMappings.vue'
import ConfigurationPremappedProductMappings from './ConfigurationPremappedProductMappings.vue'
import ConfigurationPremappedLineItemMappings from './ConfigurationPremappedLineItemMappings.vue'

export default {
  components: {    
    ConfigurationConnection,
    ConfigurationPremappedContactMappings,
    ConfigurationPremappedOrderMappings,
    ConfigurationPremappedProductMappings,
    ConfigurationPremappedLineItemMappings,    
  },
  data () {
    return { 

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
